import {API, Setup} from '../../Services';

async function ProvinceData(){
    let token =  localStorage.getItem('token');
    return API.get(`/fixtures/regions?type=0`,{headers: { 'Authorization':  `Bearer ${token}`}});
}

async function CityData(state){
    let token =  localStorage.getItem('token');
    return API.get(`/fixtures/regions?type=1`,{
        headers: { 'Authorization':  `Bearer ${token}`},
        params:{state:state}
    });
}

async function SendAddress(obj){
    let token =  localStorage.getItem('token');
    return API.post(`/users/address/`,obj,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}



// async function getAddressFromOSM(lat,lng){
//     return API.get(`https://nominatim.openstreetmap.org/search.php?q=${lat},${lng}&polygon_geojson=1&format=json`,{
//         headers:{
//             "Accept-Language":"fa"
//         }
//     });
// }

 async function getAddressFromOSM(lat,lng,neshanToken) {
    return API.get(`https://api.neshan.org/v5/reverse?lat=${lat}&lng=${lng}`,{
        headers:{
            "Api-Key":neshanToken
        }
    });
}



export {ProvinceData,CityData,SendAddress,getAddressFromOSM}
